import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api';
import { createWrapperPayload, wrapperConstants } from '../wrapper-api';

export const fetchOpportunitiesData = createAsyncThunk(
  'recommendations/fetchOpportunitiesData',
  async ({
    MOP,
    areaIds,
    businessUnitIds,
    fieldIds,
    wellIds,
  }: {
    MOP: string;
    areaIds?: string[];
    businessUnitIds?: string[];
    fieldIds?: string[];
    wellIds?: string[] | string;
  }) => {
    try {
      const requestPayload = createWrapperPayload(
        'GET',
        `/pumpchecker/api/v1/Recommendations/GetOptimizationOpportunities/${MOP}`,
        undefined,
        false,
        areaIds,
        businessUnitIds,
        fieldIds,
        wellIds,
      );
      return await api.post(wrapperConstants.router, requestPayload).then(function (response) {
        if (response) {
          return response.data;
        } else {
          return undefined;
        }
      });
    } catch (error) {
      console.error('Error fetching Opportunities Data:', error);
      return {};
    }
  },
);

export const fetchFrequencyChangeData = createAsyncThunk(
  'recommendations/fetchFrequencyChangeData',
  async (params?: {
    areaIds?: string[];
    businessUnitIds?: string[];
    fieldIds?: string[];
    wellIds?: string[] | string;
  }) => {
    try {
      const requestPayload = createWrapperPayload(
        'GET',
        `/pumpchecker/api/v1/Recommendations/GetESPRecommendationsData/frequencyChange`,
        undefined,
        false,
        params?.areaIds,
        params?.businessUnitIds,
        params?.fieldIds,
        params?.wellIds,
      );
      return await api.post(wrapperConstants.router, requestPayload).then(function (response) {
        if (response) {
          return response.data;
        } else {
          return undefined;
        }
      });
    } catch (error) {
      console.error('Error fetching Frequency Change Data:', error);
      return {};
    }
  },
);

export const fetchTrackedChangesFRQ = createAsyncThunk(
  'recommendations/fetchTrackedChangesFRQ',
  async (params?: {
    areaIds?: string[];
    businessUnitIds?: string[];
    fieldIds?: string[];
    wellIds?: string[] | string;
  }) => {
    try {
      const requestPayload = createWrapperPayload(
        'GET',
        `/pumpchecker/api/v1/TrackedChanges/GetTrackedChanges/FRQ`,
        undefined,
        false,
        params?.areaIds,
        params?.businessUnitIds,
        params?.fieldIds,
        params?.wellIds,
      );
      return await api.post(wrapperConstants.router, requestPayload).then(function (response) {
        if (response) {
          return response.data;
        } else {
          return undefined;
        }
      });
    } catch (error) {
      console.error('Error fetching Tracked Changes FRQ Data:', error);
      return {};
    }
  },
);

export const fetchESPPumpChangeData = createAsyncThunk(
  'recommendations/fetchESPPumpChangeData',
  async (params?: {
    areaIds?: string[];
    businessUnitIds?: string[];
    fieldIds?: string[];
    wellIds?: string[] | string;
  }) => {
    try {
      const requestPayload = createWrapperPayload(
        'GET',
        `/pumpchecker/api/v1/Recommendations/GetESPRecommendationsData/pumpChange`,
        undefined,
        false,
        params?.areaIds,
        params?.businessUnitIds,
        params?.fieldIds,
        params?.wellIds,
      );
      return await api.post(wrapperConstants.router, requestPayload).then(function (response) {
        if (response) {
          return response.data;
        } else {
          return undefined;
        }
      });
    } catch (error) {
      console.error('Error fetching ESP Pump Change Data:', error);
      return {};
    }
  },
);

export const fetchInjectionRateIncreaseData = createAsyncThunk(
  'recommendations/fetchInjectionRateIncreaseData',
  async (params?: {
    areaIds?: string[];
    businessUnitIds?: string[];
    fieldIds?: string[];
    wellIds?: string[] | string;
  }) => {
    try {
      const requestPayload = createWrapperPayload(
        'GET',
        `/pumpchecker/api/v1/Recommendations/GetRecommendationsData/injectionRateIncrease`,
        undefined,
        false,
        params?.areaIds,
        params?.businessUnitIds,
        params?.fieldIds,
        params?.wellIds,
      );
      return await api.post(wrapperConstants.router, requestPayload).then(function (response) {
        if (response) {
          return response.data;
        } else {
          return undefined;
        }
      });
    } catch (error) {
      console.error('Error fetching Injection Rate Increase Data:', error);
      return {};
    }
  },
);

export const fetchTrackedChangesIPI = createAsyncThunk(
  'recommendations/fetchTrackedChangesIPI',
  async (params?: {
    areaIds?: string[];
    businessUnitIds?: string[];
    fieldIds?: string[];
    wellIds?: string[] | string;
  }) => {
    try {
      const requestPayload = createWrapperPayload(
        'GET',
        `/pumpchecker/api/v1/TrackedChanges/GetTrackedChanges/IPI`,
        undefined,
        false,
        params?.areaIds,
        params?.businessUnitIds,
        params?.fieldIds,
        params?.wellIds,
      );
      return await api.post(wrapperConstants.router, requestPayload).then(function (response) {
        if (response) {
          return response.data;
        } else {
          return undefined;
        }
      });
    } catch (error) {
      console.error('Error fetching Tracked Changes IPI Data:', error);
      return {};
    }
  },
);

export const fetchInjectionRateReductionData = createAsyncThunk(
  'recommendations/fetchInjectionRateReductionData',
  async (params?: {
    areaIds?: string[];
    businessUnitIds?: string[];
    fieldIds?: string[];
    wellIds?: string[] | string;
  }) => {
    try {
      const requestPayload = createWrapperPayload(
        'GET',
        `/pumpchecker/api/v1/Recommendations/GetRecommendationsData/injectionRateReduction`,
        undefined,
        false,
        params?.areaIds,
        params?.businessUnitIds,
        params?.fieldIds,
        params?.wellIds,
      );
      return await api.post(wrapperConstants.router, requestPayload).then(function (response) {
        if (response) {
          return response.data;
        } else {
          return undefined;
        }
      });
    } catch (error) {
      console.error('Error fetching Injection Rate Reduction Data:', error);
      return {};
    }
  },
);

export const fetchWHPReductionData = createAsyncThunk(
  'recommendations/fetchWHPReductionData',
  async (params?: {
    areaIds?: string[];
    businessUnitIds?: string[];
    fieldIds?: string[];
    wellIds?: string[] | string;
  }) => {
    try {
      const requestPayload = createWrapperPayload(
        'GET',
        `/pumpchecker/api/v1/Recommendations/GetRecommendationsData/whpReduction`,
        undefined,
        false,
        params?.areaIds,
        params?.businessUnitIds,
        params?.fieldIds,
        params?.wellIds,
      );
      return await api.post(wrapperConstants.router, requestPayload).then(function (response) {
        if (response) {
          return response.data;
        } else {
          return undefined;
        }
      });
    } catch (error) {
      console.error('Error fetching WHP Reduction Data:', error);
      return {};
    }
  },
);

export const fetchDepthChangeData = createAsyncThunk(
  'recommendations/fetchDepthChangeData',
  async (params?: {
    areaIds?: string[];
    businessUnitIds?: string[];
    fieldIds?: string[];
    wellIds?: string[] | string;
  }) => {
    try {
      const requestPayload = createWrapperPayload(
        'GET',
        `/pumpchecker/api/v1/Recommendations/GetRecommendationsData/depthChange`,
        undefined,
        false,
        params?.areaIds,
        params?.businessUnitIds,
        params?.fieldIds,
        params?.wellIds,
      );
      return await api.post(wrapperConstants.router, requestPayload).then(function (response) {
        if (response) {
          return response.data;
        } else {
          return undefined;
        }
      });
    } catch (error) {
      console.error('Error fetching Depth Change Data:', error);
      return {};
    }
  },
);
